import { CardKey } from '@/page-content/group-lessons/constants/cards';
export const getGroupQuizResults = (userAnswers: (number | string)[]): CardKey => {
  const [q1, q2, q3] = userAnswers;

  // для работы: 1-13 2-123 3-0123
  if ((q1 === 1 || q1 === 3) && (q2 === 1 || q2 === 2 || q2 === 3) && (q3 === 0 || q3 === 1 || q3 === 2 || q3 === 3)) {
    return 'work';
  }

  // для собеседований: 1-0 2-234 3-0123
  if (q1 === 0 && (q2 === 2 || q2 === 3 || q2 === 4) && (q3 === 0 || q3 === 1 || q3 === 2 || q3 === 3)) {
    return 'interview';
  }

  // с нуля за 3 месяца: 1-01234 2-0 3-01234
  if ((q1 === 0 || q1 === 1 || q1 === 2 || q1 === 3 || q1 === 4) && q2 === 0 && (q3 === 0 || q3 === 1 || q3 === 2 || q3 === 3 || q3 === 4)) {
    return 'beginner';
  }

  // для профи: 1-01234 2-4 3-01234
  if ((q1 === 0 || q1 === 1 || q1 === 2 || q1 === 3 || q1 === 4) && q2 === 4 && (q3 === 0 || q3 === 1 || q3 === 2 || q3 === 3 || q3 === 4)) {
    return 'pro';
  }

  // общий английский: 1-4 2-123 3-01234
  if (q1 === 4 && (q2 === 1 || q2 === 2 || q2 === 3) && (q3 === 0 || q3 === 1 || q3 === 2 || q3 === 3 || q3 === 4)) {
    return 'common';
  }

  // Default fallback
  return 'common';
};